(() => {
  let pending;
  let rerun = false;
  let lastSignature;
  let timer;
  let agentRoot;
  let agentObserver;
  let agentSignature;

  const signature = (cart) => JSON.stringify([
    cart.item_count, cart.total_price, cart.total_discount,
    cart.items.map((item) => [item.key, item.quantity, item.final_line_price])
  ]);

  async function refresh() {
    const cartUrl = window.Shopify.routes.root + 'cart';
    const response = await fetch(cartUrl + '.js', {
      cache: 'no-store', headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Cart refresh failed');
    const cart = await response.json();
    const nextSignature = signature(cart);
    if (nextSignature === lastSignature) return;
    const sections = new Map();
    const add = (section, selector, mount) => {
      if (mount) sections.set(section, { selector, mount });
    };
    add('cart-drawer', '#CartDrawer', document.querySelector('#CartDrawer'));
    add('cart-icon-bubble', '.shopify-section', document.querySelector('#cart-icon-bubble'));
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const root = document.getElementById(id);
      if (root) add(root.dataset.id || id, '.js-contents', root.querySelector('.js-contents'));
    }
    add('cart-live-region-text', '.shopify-section', document.querySelector('#cart-live-region-text'));
    const url = new URL(cartUrl, window.location.origin);
    url.searchParams.set('sections', [...sections.keys()].join(','));
    const sectionResponse = await fetch(url, { cache: 'no-store' });
    if (!sectionResponse.ok) throw new Error('Cart sections refresh failed');
    const html = await sectionResponse.json();
    const focused = document.activeElement;
    const focusId = focused?.id;
    const focusName = focused?.getAttribute('name');
    let replacedFocused = false;
    for (const [id, { selector, mount }] of sections) {
      if (!html[id]) continue;
      const source = new DOMParser().parseFromString(html[id], 'text/html').querySelector(selector);
      if (!source) continue;
      replacedFocused ||= mount.contains(focused);
      mount.replaceChildren(...source.childNodes);
    }
    const empty = cart.item_count === 0;
    const drawer = document.querySelector('cart-drawer');
    drawer?.classList.toggle('is-empty', empty);
    document.querySelector('cart-items')?.classList.toggle('is-empty', empty);
    document.querySelector('#main-cart-footer')?.classList.toggle('is-empty', empty);
    drawer?.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    if (replacedFocused) {
      const restored = (focusId && document.getElementById(focusId)) ||
        (focusName && [...document.getElementsByName(focusName)].find((el) => el.closest('#CartDrawer'))) ||
        drawer?.querySelector('.drawer__close');
      restored?.focus({ preventScroll: true });
    }
    if (drawer?.classList.contains('active') && typeof trapFocus === 'function') {
      const focus = drawer.querySelector('.drawer__inner');
      if (focus) trapFocus(focus, replacedFocused ? document.activeElement : focus);
    }
    lastSignature = nextSignature;
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    }
  }

  function sync() {
    if (pending) {
      rerun = true;
      return pending;
    }
    pending = refresh().catch(() => {}).finally(() => {
      pending = undefined;
      if (rerun) {
        rerun = false;
        sync();
      }
    });
    return pending;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 120);
  }

  function readAgentCart() {
    const cartButton = [...agentRoot.querySelectorAll('button[aria-label]')].find((button) =>
      /(?:winkelwagen|cart|warenkorb|panier).*\d/i.test(button.getAttribute('aria-label'))
    );
    const next = cartButton?.getAttribute('aria-label');
    if (!next || next === agentSignature) return;
    agentSignature = next;
    schedule();
  }

  function attachAgent() {
    const root = document.getElementById('ads-agent-host')?.shadowRoot;
    if (!root || root === agentRoot) return;
    agentObserver?.disconnect();
    agentRoot = root;
    agentSignature = undefined;
    agentObserver = new MutationObserver(readAgentCart);
    agentObserver.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
    root.addEventListener('click', () => {
      for (const delay of [300, 1200, 3000]) setTimeout(sync, delay);
    });
    readAgentCart();
  }

  document.addEventListener('shopify:cart:lines-update', schedule);
  document.addEventListener('click', (event) => {
    if (event.target.closest?.('#cart-icon-bubble')) sync();
  }, true);
  window.addEventListener('focus', schedule);
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) schedule();
  });
  const hostObserver = new MutationObserver(attachAgent);
  hostObserver.observe(document.body, { childList: true });
  for (const delay of [0, 500, 2000, 5000]) setTimeout(attachAgent, delay);
})();
